// extracted by mini-css-extract-plugin
export var gif = "_ex-0";